import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const TableauAiAccesses = {
  permission: Access({
    description:
      "Read or write access to Tableau projects, granted to an agent user",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    generated: {
      ...VaultedSecretAccess.generated,
      // The MCP server reads where to sign in from the grant, because each
      // install has its own Tableau site.
      server: { type: "string", label: "Tableau Cloud URL" },
      contentUrl: { type: "string", label: "Site name" },
    },
    parameters: {
      site: {
        type: "dynamic",
        label: "Site",
        description: "Tableau site",
      },
      // Values are `<level>:<project id>`, e.g. "read:1f2f3e4e-…", for projects
      // whose permissions are locked to the project.
      policies: {
        type: "dynamic",
        label: "Projects",
        description: "Projects to grant read or write access to",
        multivalued: true,
      },
    },
    render: {
      locator: "site",
      policy: "policies",
    } as const,
  }),
};

export type TableauAiAccesses = typeof TableauAiAccesses;
export type TableauAiAccess = TableauAiAccesses[keyof TableauAiAccesses];
export type TableauAiPermissionAccess = TableauAiAccesses["permission"];
